import identity from 'transmute/identity';
import { InMemoryCache } from '../InMemoryCache';

// Stubbed response type with fields we are interested in

const fetchCallsSettings = (__unusedKey, httpClient) => {
  return httpClient.get('calls/v1/settings');
};
export const makeCallsSettingsCache = () => new InMemoryCache('CallsSettingsCache', fetchCallsSettings, identity);